export default __webpack_public_path__ + "static/media/ghButton.ffd06fce.png";